<template lang="pug">
  .layout
    y-dialog(fill-height fluid v-model="showModal" scrollable transition="fade-transition" persistent max-width="600px")
      v-card
        v-card-title.pa-4.white
          v-row(no-gutters)
            v-col
              h6.mb-0.mt-1.basic800--text {{ $t('select_rider') }}
            v-col.text-right
              v-btn.px-3.pt-0.button-AA-tiny(color="info500" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="clickAddRider")
                v-icon.ml-n2(left size=14) mdi-plus
                div.ml-n2.mr-n1  {{ $t('add_new') }}

        v-card-text.pa-0
          div
            v-layout.my-6(v-if="isFetching")
              v-row.fill-height.ma-0(align='center' justify='center')
                v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
            v-form(v-else ref="form")
              v-layout.my-6(v-if="riders.length == 0")
                v-row.fill-height.ma-0(align='center' justify='center')
                  div.mx-auto
                    v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                    p.caption {{ $t('no_riders_added') }}
              div(v-else)
                template(v-for='(rider, index) in riders')
                  v-card.px-2(flat :key='rider.id' @click="selectedRider = index")
                    v-row(no-gutters)
                      v-col.pa-2
                        div.p1 {{ getRider(index).name }}
                        div.c1.mt-2.basic600--text {{ $t('phone_no') }} : {{ getRider(index).phone }}
                        div.mt-1.c1.basic600--text {{ $t('plat_no') }} : {{ getRider(index).vehicle_no }}
                      v-col.pa-2.shrink
                        v-btn(icon small)
                          template(v-if="selectedRider == index")
                            v-icon(color='success') mdi-check-circle
                            //- eva-icon.mr-n1.mt-2(name="radio-button-on" :fill="$vuetify.theme.themes[$theme].basic1000" height="23")
                          template(v-else)
                            v-icon(color='primary400') mdi-radiobox-blank
                        v-menu(offset-x top left)
                          template(v-slot:activator='{ on }')
                            v-btn.mt-2(icon v-on="on" small)
                              v-icon(color="primary700" size="22") mdi-dots-vertical
                          v-list.pa-0(dense)
                            v-list-item(@click="clickEditRider(getRider(index))")
                              v-list-item-title.s2.basic800--text {{ $t('edit') }}
                            v-list-item(@click="clickDeleteRider(getRider(index))")
                              v-list-item-title.s2.basic800--text {{ $t('delete') }}
                  v-divider.basic300
                v-btn.px-0.mx-4(color="textColorAccent" text @click="openRiderMessageDialog = true")
                  span.button-Aa-small.textColorAccent--text {{ $t('edit_message_template') }}
                  eva-icon.ml-1(name="edit-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="16" height="16" style="margin-top: 3px")
        v-card-actions
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-small.primary400--text {{ $t('cancel') }}
          v-btn.mr-2(color='textColorAccent' dark depressed height=32 @click="clickShare" :loading="isLoading")
            .button-AA-small.basic100--text {{ $t('send_details') }}

    .modals
      update-rider(v-if="openUpdateRiderDialog" :open.sync="openUpdateRiderDialog" :rider="editingRider" @added="handleAddItem" @edited="handleEditItem")
      rider-message-template(v-if="openRiderMessageDialog" :open.sync="openRiderMessageDialog" :propRiderMessage.sync="riderMessage" :company="company" @refresh="checkRiderMessage")
      y-dialog(v-if="showDeleteRiderDialog" v-model='showDeleteRiderDialog', max-width='320')
        v-card
          v-card-title.h6.basic800--text.px-4 {{ $t('delete_rider') }}
          v-card-text.p2.primary500--text.px-4 {{ $t('delete_rider_confirmation') }}
          v-card-actions
            v-spacer
            v-btn(color='white', text @click='showDeleteRiderDialog = false')
              .button-Aa-small.primary400--text {{ $t('cancel') }}
            v-btn.mr-2(color='danger500' depressed height=32 @click='startDelete')
              .button-AA-small.basic100--text {{ $t('delete') }}

</template>

<script>
import UpdateRider from '@/components/dialogs/order/UpdateRider.vue'
import RiderMessageTemplate from '@/components/dialogs/order/RiderMessageTemplate.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'RiderListDialog',
  props: ['open', 'leads'],
  components: { UpdateRider, RiderMessageTemplate },
  data: () => ({
    isFetching: true,
    selectedRider: null,
    riders: [],
    items: [],
    riderMessage: null,
    openUpdateRiderDialog: false,
    openRiderMessageDialog: false,
    showDeleteRiderDialog: false,
    editingRider: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isLoading () {
      if (this.leads.length != this.items.length) {
        return true
      }
      return false
    }
  },
  mounted () {
    this.fetchRiders()
    this.checkRiderMessage()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getRider (index) {
      return this.riders[index]
    },
    fetchRiders() {
      this.$axios.get(`/shipping/riders?page_size=10&company=${this.company.id}&ordering=-id`)
        .then(resp => {
          this.riders = resp.data.results
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
          this.leads.forEach((lead) => {
            this.getInvoice(lead)
          })
        })
    },
    checkRiderMessage () {
      this.$axios.get(`/companies/${this.company.id}/settings`)
        .then(resp => {
          if (resp.data.results.length > 0) {
            if (resp.data.results.filter(f => f.name === 'yz.rider.message_template').length > 0) {
              this.riderMessage = resp.data.results.filter(f => f.name === 'yz.rider.message_template')[0]
            }
          }
        })
        .catch(() => {})
    },
    getInvoice (lead) {
      if (lead.cod) {
        this.$axios.get(`/invoices/${lead.pid}/`)
          .then((response) => {
            const item = {
              lead: lead,
              invoice: response.data,
            }
            this.items.push(item)
          })
          .catch(() => {})
      } else {
        const item = {
          lead: lead,
          invoice: null,
        }
        this.items.push(item)
      }
    },
    getShareMessages () {
      let messages = ''
      this.items.forEach((item, index) => {
        messages += this.getShareMessage(item)
        if (index != 0) {
          messages += '%0d%0a%0d%0a==========%0d%0a%0d%0a'
        }
      })
      return messages
    },
    getShareMessage (item) {
      if (this.riderMessage && this.riderMessage.extra_data) {
        return this.templatedMessage(item)
      } else {
        return this.untemplateMessage(item)
      }
    },
    templatedMessage (item) {
      let message = `Order ${encodeURIComponent('#')}${item.lead.rid}%0d%0a%0d%0a`

      // RECIPIENT MESSAGE
      if (this.riderMessage.extra_data.recipientName || this.riderMessage.extra_data.recipientPhone) {
        message += 'Recipient%0d%0a'
        if (this.riderMessage.extra_data.recipientName && item.lead.shipping_address.name) {
          message += `*Name:* ${item.lead.shipping_address.name}%0d%0a`
        }
        if (this.riderMessage.extra_data.recipientPhone && item.lead.shipping_address.phone) {
          message += `*Phone:* ${item.lead.shipping_address.phone}%0d%0a*WhatsApp:* wa.me/${this.$options.filters.phoneSanitized(item.lead.shipping_address.phone)}%0d%0a`
        }
        message += '%0d%0a'
      }

      // CUSTOMER MESSAGE
      if (this.riderMessage.extra_data.customerName || this.riderMessage.extra_data.customerPhone) {
        message += 'Customer%0d%0a'
        if (this.riderMessage.extra_data.customerName && item.lead.name) {
          message += `*Name:* ${item.lead.name}%0d%0a`
        }
        if (this.riderMessage.extra_data.customerPhone && item.lead.phone) {
          message += `*Phone:* ${item.lead.phone}%0d%0a*WhatsApp:* wa.me/${this.$options.filters.phoneSanitized(item.lead.phone)}%0d%0a`
        }
        message += '%0d%0a'
      }

      // ADDRESS / ITEM / EXPECTED MESSAGE
      if (this.riderMessage.extra_data.recipientAddress && item.lead.shipping_address) {
        message += `*Address:*%0d%0a${item.lead.shipping_address.address_1},${item.lead.shipping_address.address_2 ? `%0d%0a${item.lead.shipping_address.address_2},` : ''}%0d%0a${item.lead.shipping_address.postcode}${item.lead.shipping_address.area ? ` ${item.lead.shipping_address.area},%0d%0a${item.lead.shipping_address.suburb},` : ''} ${item.lead.shipping_address.city},%0d%0a${item.lead.shipping_address.state}, ${item.lead.shipping_address.country}.%0d%0a`
      }
      if (this.riderMessage.extra_data.products && item.lead.products && item.lead.products.length > 0) {
        let products = '*Items:*%0d%0a'
        let count = 1
        item.lead.products.forEach(prod => {
          if (prod.addons.length > 0) {
            let addmsg = ''
            prod.addons.forEach(o => {
              addmsg = addmsg.concat(` - ${encodeURIComponent(o.name)} x${o.quantity_per_set}%0d%0a`)
            })
            products = products.concat(`${count}. ${encodeURIComponent(prod.name)} (x${prod.quantity})%0d%0a${addmsg}`)
            count ++
          } else {
            products = products.concat(`${count}. ${encodeURIComponent(prod.name)} (x${prod.quantity})%0d%0a`)
            count ++
          }
        })
        message += products
      }
      if (this.riderMessage.extra_data.scheduleDateTime && item.lead.asking_delivery_date && item.lead.asking_delivery_time) {
        message += `*Expected:*%0d%0a${item.lead.asking_delivery_date} at ${item.lead.asking_delivery_time}%0d%0a`
      }
      if (this.riderMessage.extra_data.recipientAddress || this.riderMessage.extra_data.products || this.riderMessage.extra_data.scheduleDateTime) {
        message += '%0d%0a'
      }

      // OTHER MESSAGES
      if (this.riderMessage.extra_data.orderMessage && item.lead.order_remarks && item.lead.order_remarks.order_message) {
        message += `*Note:* ${item.lead.order_remarks.order_message}%0d%0a`
      }
      if (this.riderMessage.extra_data.extraInfo && item.lead.extra_fields_data && item.lead.extra_fields_data.length > 0) {
        let extraInfo = `*Extra info:*%0d%0a`
        item.lead.extra_fields_data.forEach(data => {
          extraInfo = extraInfo.concat(`- ${data.name}: ${data.value}%0d%0a`)
        })
        message += extraInfo
      }
      if (this.riderMessage.extra_data.orderMessage || this.riderMessage.extra_data.extraInfo) {
        message += '%0d%0a'
      }
      if (this.riderMessage.extra_data.receipt) {
        let receipt = `*Receipt:* `
        if (this.$subdomain) {
          receipt = receipt.concat(`${this.$subdomain}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/invoices/${item.lead.pid}%0d%0a%0d%0a`)
        } else {
          receipt = receipt.concat(`http://localhost:8080/invoices/${item.lead.pid}%0d%0a%0d%0a`)
        }
        message += receipt
      }
      if (this.riderMessage.extra_data.payment) {
        if (item.lead.paid) {
          message += '*Payment:* Paid%0d%0a'
        } else {
          message += '*Payment:* Unpaid%0d%0a'
        }
      }

      return message
    },
    untemplateMessage (item) {
      let message = `${encodeURIComponent('#')}${item.lead.rid}%0d%0a%0d%0a*Order for delivery*%0d%0a`
      let productMessage = ''
      let count = 1
      item.lead.products.forEach(prod => {
        if (prod.addons.length > 0) {
          let addmsg = ''
          prod.addons.forEach(o => {
            addmsg = addmsg.concat(` - ${encodeURIComponent(o.name)} x${o.quantity_per_set}%0d%0a`)
          })
          productMessage = productMessage.concat(`${count}. ${encodeURIComponent(prod.name)} (x${prod.quantity})%0d%0a${addmsg}`)
          count ++
        } else {
          productMessage = productMessage.concat(`${count}. ${encodeURIComponent(prod.name)} (x${prod.quantity})%0d%0a`)
          count ++
        }
      })
      message = message.concat(`${productMessage}%0d%0a`)

      const name = ((item.lead.shipping_address && item.lead.shipping_address.name) || item.lead.name)
      const phone = ((item.lead.shipping_address && item.lead.shipping_address.phone) || item.lead.phone)

      let customer = `*Customer:*%0d%0aName: ${name}%0d%0aPhone: ${phone}%0d%0aWhatsApp: wa.me/${this.$options.filters.phoneSanitized(phone)}%0d%0a%0d%0a`
      message = message.concat(customer)
      if (item.lead.shipping_address) {
        let address = `*Address:*%0d%0a${item.lead.shipping_address.address_1},${item.lead.shipping_address.address_2 ? `%0d%0a${item.lead.shipping_address.address_2},` : ''}%0d%0a${item.lead.shipping_address.postcode}${item.lead.shipping_address.area ? ` ${item.lead.shipping_address.area},%0d%0a${item.lead.shipping_address.suburb},` : ''} ${item.lead.shipping_address.city},%0d%0a${item.lead.shipping_address.state}, ${item.lead.shipping_address.country}.%0d%0a%0d%0a`
        message = message.concat(address)
      }
      let payment = 'Payment: *Paid*'
      if (item.lead.cod) {
        payment = `Payment: COD%0d%0aAmount: *${this.$options.filters.displayPrice(item.invoice.total_amount)}*`
      }
      message = message.concat(payment)
      return message
    },
    clickShare () {
      window.open(`https://api.whatsapp.com/send?phone=${this.getRider(this.selectedRider).phone}&text=${this.getShareMessages()}`)
    },
    clickDeleteRider(rider) {
      this.deleteRider = rider
      this.showDeleteRiderDialog = true
    },
    clickAddRider () {
      this.editingRider = null
      this.openUpdateRiderDialog = true
    },
    clickEditRider (rider) {
      this.editingRider = rider
      this.openUpdateRiderDialog = true
    },
    startDelete() {
      this.axios.delete(`/shipping/riders/${this.deleteRider.id}/`)
        .then(() => {
          this.selectedRider = null
          this.riders = this.riders.filter((x) => x !== this.deleteRider)
          this.showDeleteRiderDialog = false
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    handleAddItem (item) {
      this.riders.push(item)
    },
    handleEditItem (item) {
      let addToIndex = 0
      this.riders.forEach((rider, index) => {
        if (rider.id === item.id) {
          addToIndex = index
        }
      })
      this.riders = this.riders.filter((x) => x.id !== item.id)
      this.riders.splice(addToIndex, 0, item)
    }
  }
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "send_details": "Send Details",
    "select_rider": "Select rider",
    "no_riders_added": "No riders added yet",
    "phone_no": "Phone No",
    "plat_no": "Plat No",
    "edit_message_template": "Edit message template",
    "delete_rider": "Delete rider",
    "delete_rider_confirmation": "Are you sure you want to delete this rider? This rider details will be deleted permanently."
  },
  "id": {
    "send_details": "Hantar detail",
    "select_rider": "Pilih rider",
    "no_riders_added": "Tiada daftar rider",
    "phone_no": "Nomor HP",
    "plat_no": "Nomor Plat",
    "edit_message_template": "Edit template pesanan",
    "delete_rider": "Hapus rider",
    "delete_rider_confirmation": "Anda yakin ingin menghapus pengendara ini? Detail pengendara ini akan dihapus secara permanen."
  }
}
</i18n>
